export const bindTabs = (selector) => {
  if (!selector) return;

  const elements = document.querySelectorAll(selector);

  elements.forEach(element => {
    const controls = element.querySelectorAll('[data-tab-control]');

    controls.forEach(control => {
      control.addEventListener('click', () => {
        const id = control.getAttribute('data-tab-control');
        const tab = element.querySelector('[data-tab="'+id+'"]');
        const activeElements = element.querySelectorAll('[data-tab].active, [data-tab-control].active');

        if (tab && !control.classList.contains('active')) {
          activeElements.forEach(activeElement => activeElement.classList.remove('active'));
          control.classList.add('active');
          tab.classList.add('active');
        }
      });
    });
  });
}
